(function () {
  'use strict';
  let fullscreenSwiper = null;
  let isFullscreenOpen = false;
  let videoItems = [];
  let swipeHintHidden = false;
  let savedScrollY = 0;
  let touchMoveHandler = null;
  let pausedSectionVideo = null;
  let audioUnlocked = false;

  function isDesktop() {
    return window.innerWidth >= 1150;
  }

  function getOverlayElement() {
    return document.getElementById('videoFullscreenOverlay');
  }

  function getContainerElement(overlay) {
    return overlay.querySelector('.video-fullscreen-container') ||
      overlay.querySelector('.video-slider__overlay-container');
  }

  function getSliderElement(overlay) {
    return overlay.querySelector('.video-fullscreen-slider') ||
      overlay.querySelector('.video-slider__fullscreen');
  }

  function getSlideSelector() {
    return '.fullscreen-slide, .video-slider__slide';
  }

  function getMediaContainerSelector() {
    return '.fullscreen-video-container, .video-slider__slide-media';
  }

  function getVideoSelector() {
    return '.fullscreen-video-element, .video-slider__slide-video';
  }

  function getImageSelector() {
    return '.fullscreen-image-element, .video-slider__slide-image';
  }

  function getPlayButtonSelector() {
    return '.fullscreen-play-btn, .video-slider__slide-play-btn';
  }

  function getLoaderSelector() {
    return '.video-slider__slide-loader';
  }

  function getHintId() {
    return 'fullscreenSwipeHint';
  }

  function unlockAudio() {
    if (audioUnlocked) return;
    audioUnlocked = true;

    var overlay = getOverlayElement();
    if (!overlay) return;

    overlay.querySelectorAll(getVideoSelector()).forEach(function (v) {
      try {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.then === 'function') {
          p.then(function () {
            v.pause();
            try { v.currentTime = 0; } catch (e) {}
          }).catch(function () {});
        } else {
          v.pause();
        }
      } catch (e) {}
    });
  }

  function setSlideState(slide, state) {
    if (!slide) return;
    var loader = slide.querySelector(getLoaderSelector());
    var media = slide.querySelector(getMediaContainerSelector());
    var playBtn = slide.querySelector(getPlayButtonSelector());

    if (loader) loader.classList.remove('is-visible');
    if (media) {
      media.classList.remove('is-playing');
      media.classList.remove('is-loading');
    }
    if (playBtn) playBtn.style.display = 'none';

    if (state === 'loading') {
      if (media) media.classList.add('is-loading');
      if (loader) loader.classList.add('is-visible');
    } else if (state === 'playing') {
      if (media) media.classList.add('is-playing');
    } else if (state === 'paused') {
      if (media) media.classList.add('is-playing');
      if (playBtn) playBtn.style.display = 'flex';
    }
  }

  function hideAllLoaders() {
    document.querySelectorAll(getSlideSelector()).forEach(function (slide) {
      setSlideState(slide, 'idle');
    });
  }

  function lockBodyScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
    document.body.style.overscrollBehavior = 'none';

    touchMoveHandler = function (e) {
      if (!isFullscreenOpen) return;
      if (e.target.closest && e.target.closest('.swiper-wrapper')) {
        return;
      }
      e.preventDefault();
    };

    var overlay = getOverlayElement();
    if (overlay) {
      overlay.addEventListener('touchmove', touchMoveHandler, { passive: false });
    }
  }

  function unlockBodyScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
    document.body.style.overscrollBehavior = '';

    var overlay = getOverlayElement();
    if (overlay && touchMoveHandler) {
      overlay.removeEventListener('touchmove', touchMoveHandler);
      touchMoveHandler = null;
    }

    window.scrollTo(0, savedScrollY);
  }

  function initMainSliders() {
    document.querySelectorAll('.complementary-products-slider').forEach((el, i) => {
      try {
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
        new Swiper(el, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          }
        });
      } catch (e) {
        console.error('Complementary slider ' + (i + 1) + ':', e);
      }
    });

    document.querySelectorAll('.customer-videos__items').forEach((el, i) => {
      try {
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
        new Swiper(el, {
          slidesPerView: 3.75,
          spaceBetween: 12,
        });
      } catch (e) {
        console.error('Customer videos slider ' + (i + 1) + ':', e);
      }
    });

    document.querySelectorAll('.video-slider__items').forEach((el, i) => {
      try {
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
        new Swiper(el, {
          slidesPerView: 1.25,
          spaceBetween: 20,
          breakpoints: {
            700: {
              slidesPerView: 2.3,
              spaceBetween: 20,
            },
            1000: {
              slidesPerView: 4.15,
              spaceBetween: 24,
            }
          }
        });
      } catch (e) {
        console.error('Video slider ' + (i + 1) + ':', e);
      }
    });
  }

  function collectVideoItems() {
    videoItems = [];
    document.querySelectorAll('.customer-videos__item, .video-slider__item').forEach(function (item) {
      var videoIndex = parseInt(item.dataset.videoIndex);
      if (!isNaN(videoIndex)) {
        videoItems.push({
          index: videoIndex,
          element: item
        });
      }
    });
  }

  function hideSwipeHint() {
    if (swipeHintHidden) return;
    swipeHintHidden = true;

    var hint = document.getElementById(getHintId());
    if (hint) {
      hint.classList.add('hidden');
    }
  }

  function setupSwipeHintDismiss() {
    if (isDesktop()) return;

    var overlay = getOverlayElement();
    if (!overlay) return;

    var dismissEvents = [
      'click', 'touchstart', 'touchmove', 'touchend',
      'wheel', 'keydown'
    ];

    var dismissHandler = function (e) {
      if (e.target.closest && (
        e.target.closest('.fullscreen-swipe-hint') ||
        e.target.closest('.video-slider__swipe-hint')
      )) {
        return;
      }
      hideSwipeHint();
    };

    dismissEvents.forEach(function (eventName) {
      overlay.addEventListener(eventName, dismissHandler, { passive: true, capture: true });
    });

    overlay._dismissHandler = dismissHandler;
    overlay._dismissEvents = dismissEvents;
  }

  function resetSwipeHint() {
    if (isDesktop()) return;

    swipeHintHidden = false;
    var hint = document.getElementById(getHintId());
    if (hint) {
      hint.classList.remove('hidden');
      hint.style.animation = 'none';
      void hint.offsetHeight;
      hint.style.animation = 'swipeHintAppear 0.5s ease forwards 0.5s';
    }
  }

  function getSlideMediaWidth(index) {
    if (!fullscreenSwiper) return 0;
    var slide = fullscreenSwiper.slides[index];
    if (!slide) return 0;

    var media = slide.querySelector(getMediaContainerSelector());
    if (!media) return 0;

    var video = media.querySelector(getVideoSelector());
    var img = media.querySelector(getImageSelector()) ||
      media.querySelector('img');

    var vh = window.innerHeight;
    var maxW = window.innerWidth;

    if (video && video.videoWidth && video.videoHeight) {
      return Math.min(vh * (video.videoWidth / video.videoHeight), maxW * 0.9);
    }
    if (img && img.naturalWidth && img.naturalHeight) {
      return Math.min(vh * (img.naturalWidth / img.naturalHeight), maxW * 0.95);
    }

    return Math.min(vh * (9 / 16), maxW * 0.9);
  }

  function updateOverlayWidth(index) {
    if (!isDesktop()) return;

    var overlay = getOverlayElement();
    if (!overlay || !fullscreenSwiper) return;

    var container = getContainerElement(overlay);
    if (!container) return;

    var targetIndex = typeof index === 'number' ? index : fullscreenSwiper.activeIndex;
    var width = getSlideMediaWidth(targetIndex);
    if (!width) return;

    container.style.width = width + 'px';
  }

  function setupDelegatedClicks() {
    document.addEventListener('click', function (e) {
      if (isFullscreenOpen) {
        unlockAudio();
      }

      var cvPlayBtn = e.target.closest('.video-play-btn');
      if (cvPlayBtn) {
        e.preventDefault();
        e.stopPropagation();
        var cvVideoId = parseInt(cvPlayBtn.getAttribute('data-video-id'));
        if (!isNaN(cvVideoId)) openFullscreen(cvVideoId);
        return;
      }

      var playBtn = e.target.closest('.video-slider__play-btn');
      if (playBtn) {
        e.preventDefault();
        e.stopPropagation();
        var videoId = parseInt(playBtn.getAttribute('data-video-id'));
        if (!isNaN(videoId)) openFullscreen(videoId);
        return;
      }

      var itemVideo = e.target.closest('.video-slider__item video');
      if (itemVideo) {
        e.stopPropagation();
        var slide = itemVideo.closest('.video-slider__item');
        if (slide) {
          var idx = parseInt(slide.dataset.videoIndex);
          if (!isNaN(idx)) {
            pausedSectionVideo = itemVideo;
            itemVideo.pause();
            openFullscreen(idx);
          }
        }
        return;
      }

      var itemImg = e.target.closest('.video-slider__item .video-slider__image');
      if (itemImg) {
        e.stopPropagation();
        var slideImg = itemImg.closest('.video-slider__item');
        if (slideImg) {
          var idxImg = parseInt(slideImg.dataset.videoIndex);
          if (!isNaN(idxImg)) openFullscreen(idxImg);
        }
        return;
      }

      var cvVideo = e.target.closest('.customer-videos__item video');
      if (cvVideo) {
        e.stopPropagation();
        var cvSlide = cvVideo.closest('.customer-videos__item');
        if (cvSlide) {
          var cvIdx = parseInt(cvSlide.dataset.videoIndex);
          if (!isNaN(cvIdx)) {
            cvVideo.pause();
            openFullscreen(cvIdx);
          }
        }
        return;
      }

      var cvImg = e.target.closest('.customer-videos__item .customer-image');
      if (cvImg) {
        e.stopPropagation();
        var cvSlideImg = cvImg.closest('.customer-videos__item');
        if (cvSlideImg) {
          var cvIdxImg = parseInt(cvSlideImg.dataset.videoIndex);
          if (!isNaN(cvIdxImg)) openFullscreen(cvIdxImg);
        }
        return;
      }
    });
  }

  function togglePlay(video) {
    if (video.paused) {
      unlockAudio();

      video.muted = false;
      video.volume = 1;

      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          video.muted = true;
          video.play().catch(function (err) {
            console.error('Play error:', err);
          });
        });
      }
    } else {
      video.pause();
    }
  }

  function handleVideoClick(e) {
    e.stopPropagation();
    var video = e.currentTarget;
    togglePlay(video);
  }

  function handlePlayButtonClick(e) {
    e.stopPropagation();
    var playBtn = e.currentTarget;
    var container = playBtn.closest('.fullscreen-video-container') ||
      playBtn.closest('.video-slider__slide-media');
    if (!container) return;

    var video = container.querySelector('.fullscreen-video-element') ||
      container.querySelector('.video-slider__slide-video');
    if (!video) return;

    togglePlay(video);
  }

  function setupVideoControls(video, container) {
    var slide = container.closest(getSlideSelector());
    var playBtn = container.querySelector(getPlayButtonSelector());

    video.removeEventListener('play', video._onPlay);
    video.removeEventListener('pause', video._onPause);
    video.removeEventListener('playing', video._onPlaying);
    video.removeEventListener('waiting', video._onWaiting);
    video.removeEventListener('canplay', video._onCanPlay);
    video.removeEventListener('canplaythrough', video._onCanPlayThrough);
    video.removeEventListener('error', video._onError);
    video.removeEventListener('stalled', video._onStalled);
    video.removeEventListener('click', handleVideoClick);

    video._onPlay = function () {
      if (video.readyState >= 2) {
        setSlideState(slide, 'playing');
      } else {
        setSlideState(slide, 'loading');
      }
    };

    video._onPause = function () {
      clearTimeout(video._loadingTimeout);
      if (!fullscreenSwiper) return;
      var slideIndex = fullscreenSwiper.slides.indexOf(slide);
      if (slideIndex !== fullscreenSwiper.activeIndex) return;
      if (!video.seeking && video.readyState >= 2) {
        setSlideState(slide, 'paused');
      }
    };

    video._onPlaying = function () {
      clearTimeout(video._loadingTimeout);
      setSlideState(slide, 'playing');
    };

    video._onWaiting = function () {
      if (video.readyState < 2) {
        setSlideState(slide, 'loading');
        clearTimeout(video._loadingTimeout);
        video._loadingTimeout = setTimeout(function () {
          if (video.readyState < 2) {
            setSlideState(slide, 'paused');
          }
        }, 8000);
      }
    };

    video._onCanPlay = function () {
      clearTimeout(video._loadingTimeout);
      if (video.paused) {
        var slideIndex = fullscreenSwiper ? fullscreenSwiper.slides.indexOf(slide) : -1;
        if (fullscreenSwiper && slideIndex === fullscreenSwiper.activeIndex) {
          setSlideState(slide, 'paused');
        }
      } else {
        setSlideState(slide, 'playing');
      }
    };

    video._onCanPlayThrough = function () {
      clearTimeout(video._loadingTimeout);
      if (!video.paused) {
        setSlideState(slide, 'playing');
      }
    };

    video._onError = function () {
      clearTimeout(video._loadingTimeout);
      setSlideState(slide, 'paused');
    };

    video._onStalled = function () {
      clearTimeout(video._loadingTimeout);
      video._loadingTimeout = setTimeout(function () {
        if (video.readyState < 2) {
          setSlideState(slide, 'paused');
        }
      }, 8000);
    };

    video.addEventListener('play', video._onPlay);
    video.addEventListener('pause', video._onPause);
    video.addEventListener('playing', video._onPlaying);
    video.addEventListener('waiting', video._onWaiting);
    video.addEventListener('canplay', video._onCanPlay);
    video.addEventListener('canplaythrough', video._onCanPlayThrough);
    video.addEventListener('error', video._onError);
    video.addEventListener('stalled', video._onStalled);
    video.addEventListener('click', handleVideoClick);

    if (playBtn) {
      playBtn.removeEventListener('click', handlePlayButtonClick);
      playBtn.addEventListener('click', handlePlayButtonClick);
    }

    if (video.readyState >= 2) {
      if (video.paused) {
        setSlideState(slide, 'paused');
      } else {
        setSlideState(slide, 'playing');
      }
    } else if (video.paused) {
      setSlideState(slide, 'paused');
    } else {
      setSlideState(slide, 'loading');
    }
  }

  function setupVideoClickHandlers() {
    document.querySelectorAll(getMediaContainerSelector()).forEach(function (container) {
      var video = container.querySelector(getVideoSelector());
      if (video) {
        setupVideoControls(video, container);
      }
    });
  }

  function setupCloseButton() {
    var closeBtn = document.getElementById('videoFullscreenClose');
    var overlay = getOverlayElement();

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeFullscreen();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeFullscreen();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isFullscreenOpen) {
        closeFullscreen();
      }
    });
  }

  function deactivateOtherSlides(swiper) {
    swiper.slides.forEach(function (slide, i) {
      if (i === swiper.activeIndex) return;

      var v = slide.querySelector(getVideoSelector());
      if (v) {
        clearTimeout(v._loadingTimeout);
        if (!v.paused) v.pause();
        try {
          v.currentTime = 0;
        } catch (e) {}
      }

      var loader = slide.querySelector(getLoaderSelector());
      var playBtn = slide.querySelector(getPlayButtonSelector());
      var media = slide.querySelector(getMediaContainerSelector());

      if (loader) loader.classList.remove('is-visible');
      if (playBtn) playBtn.style.display = 'none';
      if (media) {
        media.classList.remove('is-loading');
        media.classList.add('is-playing');
      }
    });
  }

  function preloadNeighbors(swiper) {
    var active = swiper.activeIndex;
    var total = swiper.slides.length;

    [-1, 1].forEach(function (offset) {
      var idx = active + offset;
      if (idx < 0 || idx >= total) return;

      var slide = swiper.slides[idx];
      if (!slide) return;

      var v = slide.querySelector(getVideoSelector());
      if (!v) return;

      if (v.readyState === 0 && v.networkState === 0) {
        v.preload = 'auto';
        v.load();
      }
    });
  }

  function playActiveVideo(video, slide, swiper) {
    var hasFrame = video.readyState >= 2;

    if (hasFrame) {
      setSlideState(slide, 'playing');
    } else {
      setSlideState(slide, 'loading');
    }

    video.muted = !audioUnlocked;
    video.volume = 1;

    var p = video.play();

    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        video.muted = true;
        var p2 = video.play();
        if (p2 && typeof p2.catch === 'function') {
          p2.catch(function () {
            if (!hasFrame) setSlideState(slide, 'paused');
          });
        }
      });
    }
  }

  function activateSlide(swiper) {
    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    var video = activeSlide.querySelector(getVideoSelector());
    if (!video) {
      setSlideState(activeSlide, 'idle');
      return;
    }

    if (video.error) {
      setSlideState(activeSlide, 'paused');
      return;
    }

    if (video.readyState >= 2) {
      playActiveVideo(video, activeSlide, swiper);
    } else {
      setSlideState(activeSlide, 'loading');

      var onReady = function () {
        video.removeEventListener('loadeddata', onReady);
        video.removeEventListener('canplay', onReady);
        if (swiper.slides[swiper.activeIndex] !== activeSlide) return;
        playActiveVideo(video, activeSlide, swiper);
      };

      video.addEventListener('loadeddata', onReady);
      video.addEventListener('canplay', onReady);

      if (video.networkState === 0 || video.readyState === 0) {
        video.preload = 'auto';
        video.load();
      }

      playActiveVideo(video, activeSlide, swiper);
    }

    clearTimeout(video._loadingTimeout);
    video._loadingTimeout = setTimeout(function () {
      if (video.readyState < 2 && swiper.slides[swiper.activeIndex] === activeSlide) {
        setSlideState(activeSlide, 'paused');
      }
    }, 8000);
  }

  function createFullscreenSwiper(safeIndex) {
    var overlay = getOverlayElement();
    if (!overlay) return;

    var sliderEl = getSliderElement(overlay);
    if (!sliderEl) return;

    var desktop = isDesktop();

    if (fullscreenSwiper) {
      var currentDirection = fullscreenSwiper.params.direction;
      var newDirection = desktop ? 'horizontal' : 'vertical';

      if (currentDirection !== newDirection) {
        fullscreenSwiper.changeDirection(newDirection, true);
        fullscreenSwiper.params.navigation = desktop ? {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev'),
        } : false;
        if (fullscreenSwiper.navigation) {
          fullscreenSwiper.navigation.init();
          fullscreenSwiper.navigation.update();
        }
      }

      fullscreenSwiper.slideTo(safeIndex, 0);
      updateOverlayWidth(safeIndex);
      activateSlide(fullscreenSwiper);
      preloadNeighbors(fullscreenSwiper);
      return;
    }

    fullscreenSwiper = new Swiper(sliderEl, {
      direction: desktop ? 'horizontal' : 'vertical',
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: safeIndex,
      speed: 400,
      resistanceRatio: 0.85,
      watchSlidesProgress: true,
      preloadImages: false,
      lazy: false,
      navigation: desktop ? {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev'),
      } : false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      keyboard: {
        enabled: true,
      },
      on: {
        slideChangeTransitionStart: function () {
          var nextIndex = this.activeIndex;
          var nextSlide = this.slides[nextIndex];

          if (nextSlide) {
            var nextVideo = nextSlide.querySelector(getVideoSelector());
            if (nextVideo && nextVideo.readyState < 2) {
              setSlideState(nextSlide, 'loading');
            }
          }

          requestAnimationFrame(function () {
            updateOverlayWidth(nextIndex);
          });
        },
        slideChange: function () {
          deactivateOtherSlides(this);
        },
        slideChangeTransitionEnd: function () {
          activateSlide(this);
          preloadNeighbors(this);
          if (!swipeHintHidden) resetSwipeHint();
          requestAnimationFrame(function () {
            updateOverlayWidth(this.activeIndex);
          }.bind(this));
        },
        init: function () {
          updateOverlayWidth(this.activeIndex);
          activateSlide(this);
          preloadNeighbors(this);
        }
      }
    });

    setupVideoClickHandlers();

    var activeSlide = fullscreenSwiper.slides[safeIndex];
    if (activeSlide) {
      var img = activeSlide.querySelector('img');
      if (img && !img.complete) {
        img.addEventListener('load', function () {
          updateOverlayWidth(fullscreenSwiper.activeIndex);
        }, { once: true });
      }
    }

    setTimeout(function () {
      updateOverlayWidth(fullscreenSwiper.activeIndex);
    }, 100);
  }

  function openFullscreen(startIndex) {
    if (isFullscreenOpen) return;

    resetSwipeHint();
    hideAllLoaders();

    var overlay = getOverlayElement();
    if (!overlay) return;

    var slides = overlay.querySelectorAll(getSlideSelector());
    if (slides.length === 0) return;

    var safeIndex = (typeof startIndex === 'number' && startIndex >= 0 && startIndex < slides.length)
      ? startIndex
      : 0;

    overlay.style.display = 'flex';
    overlay.classList.add('active');
    lockBodyScroll();
    isFullscreenOpen = true;

    unlockAudio();

    createFullscreenSwiper(safeIndex);
    setupSwipeHintDismiss();
  }

  function closeFullscreen() {
    if (!isFullscreenOpen) return;

    var overlay = getOverlayElement();
    if (!overlay) return;

    if (overlay._dismissHandler && overlay._dismissEvents) {
      overlay._dismissEvents.forEach(function (eventName) {
        overlay.removeEventListener(eventName, overlay._dismissHandler, { capture: true });
      });
      delete overlay._dismissHandler;
      delete overlay._dismissEvents;
    }

    swipeHintHidden = false;
    var hint = document.getElementById(getHintId());
    if (hint) {
      hint.classList.add('hidden');
    }

    document.querySelectorAll(getVideoSelector()).forEach(function (v) {
      if (!v.paused) v.pause();
      clearTimeout(v._loadingTimeout);
      try {
        v.currentTime = 0;
      } catch (e) {}
    });

    hideAllLoaders();

    overlay.classList.remove('active');
    unlockBodyScroll();
    isFullscreenOpen = false;

    if (pausedSectionVideo) {
      var parentItem = pausedSectionVideo.closest('.video-slider__item');
      if (parentItem) {
        pausedSectionVideo.play().catch(function () {});
      }
      pausedSectionVideo = null;
    }

    var container = getContainerElement(overlay);
    if (container) {
      container.style.width = '';
    }

    setTimeout(function () {
      overlay.style.display = 'none';
    }, 300);
  }

  function handleResize() {
    if (!isFullscreenOpen || !fullscreenSwiper) return;

    var desktop = isDesktop();
    var currentDirection = fullscreenSwiper.params.direction;
    var newDirection = desktop ? 'horizontal' : 'vertical';

    if (currentDirection !== newDirection) {
      fullscreenSwiper.changeDirection(newDirection, true);
      fullscreenSwiper.params.navigation = desktop ? {
        nextEl: fullscreenSwiper.el.querySelector('.swiper-button-next'),
        prevEl: fullscreenSwiper.el.querySelector('.swiper-button-prev'),
      } : false;
      if (fullscreenSwiper.navigation) {
        fullscreenSwiper.navigation.init();
        fullscreenSwiper.navigation.update();
      }
    }

    if (!desktop) {
      var overlay2 = getOverlayElement();
      var container2 = overlay2 ? getContainerElement(overlay2) : null;
      if (container2) container2.style.width = '';
      return;
    }

    updateOverlayWidth(fullscreenSwiper.activeIndex);
  }

  function init() {
    initMainSliders();
    collectVideoItems();
    setupDelegatedClicks();
    setupCloseButton();

    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('readystatechange', function handler() {
      if (document.readyState === 'complete') {
        init();
        document.removeEventListener('readystatechange', handler);
      }
    });
  }
})();

const drawers = document.querySelectorAll('.drawer');

drawers.forEach(drawer => {
  const content = drawer.shadowRoot?.querySelector('[part="content"]');
  if (!content) return;

  const checkScroll = () => {
    const hasScroll = content.scrollHeight > content.clientHeight;
    drawer.toggleAttribute('data-content-scroll', hasScroll);
  };

  const observer = new ResizeObserver(checkScroll);
  observer.observe(content);
  checkScroll();
});